import { Link } from "react-router-dom";
import { BookOpen, ArrowDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BOOK } from "@/data/book";

export default function Hero() {
  return (
    <section data-testid="hero-section" className="relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${BOOK.images.hero})` }}
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background/40 via-background/60 to-background dark:from-background/60 dark:via-background/75 dark:to-background" aria-hidden="true" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-32 md:pt-32 md:pb-40">
        <div className="max-w-3xl animate-fade-up">
          <p className="font-ui text-[11px] uppercase tracking-[0.35em] text-primary mb-6 flex items-center gap-3">
            <span className="h-px w-10 bg-primary inline-block" />
            New Ways Today — A Field Guide
          </p>
          <h1 className="font-display font-medium text-5xl sm:text-6xl lg:text-7xl tracking-tight leading-[0.95] text-foreground">
            {BOOK.title}
          </h1>
          <p className="mt-6 font-display italic text-2xl md:text-3xl text-secondary leading-snug max-w-2xl">
            {BOOK.subtitle}
          </p>
          <p className="mt-8 font-body text-lg md:text-xl text-foreground/80 max-w-2xl leading-relaxed">
            {BOOK.tagline}. Thirteen truths, gathered and expanded — the same mountain described
            by clinicians, monks and Stoics in different tongues. Read it slowly. The aim is not to feel
            exposed. The aim is to feel awake.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <Button
              asChild
              size="lg"
              data-testid="hero-cta-read"
              className="rounded-full h-12 px-7 bg-secondary text-secondary-foreground hover:bg-secondary/90 font-ui text-sm tracking-wide"
            >
              <Link to="/read">
                <BookOpen className="h-4 w-4 mr-2" />
                Start reading
              </Link>
            </Button>
            <Button
              asChild
              variant="outline"
              size="lg"
              data-testid="hero-cta-signup"
              className="rounded-full h-12 px-7 border-primary text-primary hover:bg-primary hover:text-primary-foreground font-ui text-sm tracking-wide"
            >
              <a href="#signup">
                Get the free book
                <ArrowDown className="h-4 w-4 ml-2" />
              </a>
            </Button>
          </div>

          <div className="mt-12 flex items-center gap-6 text-sm font-ui text-muted-foreground">
            <div className="flex items-center gap-2">
              <span className="h-2 w-2 rounded-full bg-primary inline-block" />
              13 chapters · ~45 min read
            </div>
            <div className="hidden sm:flex items-center gap-2">
              <span className="h-2 w-2 rounded-full bg-secondary inline-block" />
              by {BOOK.author}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
